import axios from '@/axios';
import router from '@/router';
import {dev} from '@/api/url';

// サーバーURL
const baseUrl = dev; //エンドポイント

const config = {
  timeout: 30000,
  method: null, // POSTメソッドを設定
  url: '',
  data: null,
  withCredentials: true,
};

export default {
  checkProperty: (
    authUserId,
    sessionKey,
    staffName,
    propertyList
  ) => {
    config.url = baseUrl + "/api/property/check";
    config.method = "post";

    config.data = {
      authInfo: {
        authUserId,
        sessionKey,
      },
      staffName,
      propertyList
    };

    return axios.request(config)
      .then(res => { return res; })
      .catch(err => {
        let ErrMsg = '';
        if (err.code === 'ERR_NETWORK') {
          ErrMsg = err.message; // ネットワークエラー発生時
        } else if (err.response) {
          if (err.response.status === 401) {
            ErrMsg = err.response.data.msg; // 認証エラー発生時
            router.push('/login'); // ログインページにリダイレクト
          } else {
            ErrMsg = err.response.data.msg; // その他のエラーメッセージ
          }
        } else {
          ErrMsg = err.message; // その他のエラーメッセージ
        }
        return ErrMsg; // エラーメッセージを返す
      });
  },
}